<template>
  <slick ref="slick" :options="small ? slickOptionsMobile : slickOptions">
    <b-col class="my-3" v-for="(article, index) in contents" :key="index">
      <b-card
        :img-src="article.img"
        :img-alt="article.title"
        img-top
        tag="article"
      >
        <b-card-text>
          <h5>{{ article.title }}</h5>
          <span style="font-size: 14px;">{{ article.caption }}</span>
        </b-card-text>

        <b-button size="sm" variant="outline-primary" @click="emitToParent(article.whereTo)">Read More</b-button>
      </b-card>
    </b-col>
  </slick>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Carousel_Article',
  props: ['contents'],
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        // options can be used from the plugin documentation
        autoplay: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: ''
      },
      slickOptionsMobile: {
        // options can be used from the plugin documentation
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: ''
      },

      small: null,
      large: null
    }
  },
  created: function () {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    // PREREQUISITES
    resize: function () {
      if (screen.width <= 600) this.small = true
      else this.small = false

      if (screen.width > 600) this.large = true
      else this.large = false
    },
    // END PREREQUISITES

    /* vue slick prerequisites */
    next: function () {
      this.$refs.slick.next()
    },
    prev: function () {
      this.$refs.slick.prev()
    },
    reInit: function () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick()
    },
    /* END vue slick prerequisites */
    emitToParent: function (param) {
      this.$emit('passToParent', param)
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.1);
}
.card-body {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel/Article/Article.vue